import React from 'react'
import styled from 'styled-components'
import { formatUTCDay } from 'utils/analytics/date'

const TooltipContainer = styled.div`
  background: ${({ theme }) => theme.backgroundSurface};
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  max-width: 340px;
  min-width: 280px;
`

const TooltipSubHeader = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
  margin-bottom: 8px;
`

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`

const Label = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
`

const Value = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.textPrimary};
  text-align: right;
`

const SuccessValue = styled(Value)`
  color: ${({ theme }) => theme.accentSuccess};
`

interface ApyTooltipProps {
  active?: boolean
  payload?: any[]
  label?: any
}

export const ApyTooltip: React.FC<ApyTooltipProps> = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) {
    return null
  }

  const data = payload[0].payload

  const formattedDateTime = formatUTCDay((data.timestamp ?? Date.now()) / 1000, 'MMM D, YYYY HH:mm')

  return (
    <TooltipContainer>
      <TooltipSubHeader>{formattedDateTime}</TooltipSubHeader>

      <InfoRow>
        <Label>APY:</Label>
        <SuccessValue>{`${parseFloat(data.apy || 0).toFixed(2)}%`}</SuccessValue>
      </InfoRow>

      {data.dailyGrowth !== undefined && (
        <InfoRow>
          <Label>Daily Growth:</Label>
          <SuccessValue>{`${parseFloat(data.dailyGrowth).toFixed(4)}%`}</SuccessValue>
        </InfoRow>
      )}

      <InfoRow>
        <Label>Share Price:</Label>
        <Value>{parseFloat(data.sharePrice).toFixed(8)}</Value>
      </InfoRow>

      {data.compoundNumber !== undefined && (
        <InfoRow>
          <Label>Compounds Up To Date:</Label>
          <Value>{data.compoundNumber}</Value>
        </InfoRow>
      )}
    </TooltipContainer>
  )
}

export default ApyTooltip
